import React from 'react';
import { withRouter } from 'react-router-dom';
import { Col, FormGroup, Row, Panel, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { SaveCancel, Label, ActionButton } from 'fw/components';
import { Switch, Form, TextBox, EmailBox, Avatar, Combo } from 'fw/forms';
import { PhoneBox, CompanyMultiselect } from 'areas/shared/controls'
import * as FormManager from 'fw/forms/form/FormManager';
import * as API from 'modules/app/API';
import * as App from 'modules/app/App';
import * as Notifications from 'fw/globals/Notifications';
import * as Help from 'modules/app/Help';
import * as Recent from 'modules/app/Recent';
import * as Modals from 'fw/globals/Modals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

class ProfileTab extends React.Component {

	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
			loading: true,
			title: "",
			form: {},
			resourceList: []
		};
	}

	load = () => {
		this.getResources();
	}

	getResources = (userId) => {
		API.Security.get('/profile/getResources', { userId: userId }, {
			success: (r) => {
				this.setState({
					resourceList: r.data.items
				});
			}
		});
	}

	get = () => {
		API.Security.get('/profile/getProfile', {},
			{
				success: (r) => {
					this.setState((prevState, props) => ({
						loading: false,
						form: r.data
					}));
				}
			});
	}

	save = () => {
		const form = this.state.form;
		const me = this;

		let rq = {
			email: form.email,
			firstName: form.firstName,
			lastName: form.lastName,
			primaryPhone: form.primaryPhone,
			secondaryPhone: form.secondaryPhone,
			landingPage: form.landingPage,
			avatarData: form.avatarData,
			subscribedCompanies: form.subscribedCompanies,
			userSubscribed: form.userSubscribed
		};

		API.Security.post('/profile/updateProfile', rq,
			{
				success: (r) => {
					me.updateContext();
					Notifications.success(r.message);
				},
				error: (r) => {
					Notifications.error(r.error.errorMessage);
				}
			});
	}

	cancel = () => {
		this.props.history.push('/');
	}

	updateContext = () => {
		if (!App.context().impersonating)
			App.updateUserName(this.state.form.firstName + " " + this.state.form.lastName);

		App.updateAuditUserName(this.state.form.firstName + " " + this.state.form.lastName);
		window.location.reload();
	}

	onSubmit = () => {
		this.save();
	}

	onCancel = () => {
		const me = this;

		FormManager.checkUnsavedChanges(function () {
			me.cancel();
		})
	}

	onChange = (form) => {
		this.setState({ form });
	}

	setHelp = () => {
        if (this.props.helpKey)
            Help.setHelp(this.props.helpKey)
        else
            Help.clearHelp();
	}

	addRecent() {
		Recent.add({
			activityTitle: "My Profile",
			recentType: "myProfile"
		});
	}

	componentDidMount() {
		this.load();
		this.get(this.props.selectedId);
		this.setHelp();
		this.addRecent();
	}

	handleSendTestSMS = () => {
        const me = this;

        Modals.confirm("This will send a test SMS to this user. Are you sure?", () => {
            API.Security.get('/profile/sendTestSMS', { userId: me.state.form.userId }, {
                success: (r) => {
					Notifications.success(r.message);
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
        });
    }

	render() {
		const sponsorUnsubscribedTooltip = (
            <Tooltip id="sponsorUnsubscribedTooltip">
                Email notifications have been disabled at Corporate Member level.
            </Tooltip>
        );

		if (this.state.loading)
			return null;

		const { primaryPhone, secondaryPhone } = this.state.form;
		let verificationPhone = null;

		if (primaryPhone && (!primaryPhone.phoneTypeCode || primaryPhone.phoneTypeCode.toUpperCase() === "MOBILE"))
			verificationPhone = primaryPhone;
		else if (secondaryPhone && (!secondaryPhone.phoneTypeCode || secondaryPhone.phoneTypeCode.toUpperCase() === "MOBILE"))
			verificationPhone = secondaryPhone;

		return (
			<React.Fragment>
				<h2>{App.context().auditUserName}</h2>
				<hr />
				<Form
					onChange={this.onChange}
					onSubmit={this.onSubmit}
					values={this.state.form}
					unsavedChangesWarning={true}>
					<Row>
						<Col md={7}>
							<FormGroup>
								<Label htmlFor="login">Login</Label>
								<TextBox name="login" disabled />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="firstName" required>First name</Label>
								<TextBox 
									name="firstName" 
									placeholder="First Name"
									maxLength="30" 
									required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="lastName" required>Last name</Label>
								<TextBox 
									name="lastName" 
									placeholder="Last Name"
									maxLength="30" 
									required />
							</FormGroup>
							<Row>
								<Col md={6}>
									<FormGroup>
										<Label htmlFor="primaryPhone">Primary phone</Label>
										<div className="form-inline" >
											<PhoneBox name="primaryPhone" />
										</div>
									</FormGroup>
								</Col>
								<Col md={6}>
									<FormGroup>
										<Label htmlFor="secondaryPhone">Secondary phone</Label>
										<div className="form-inline" >
											<PhoneBox name="secondaryPhone" />
										</div>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col md={6}>
									{verificationPhone &&
										<Panel style={{ marginTop: "25px" }}>
											<Panel.Body>
												<Row>
													<Col md={7}>
														<FormGroup>
															<Label htmlFor="verificationPhone">Your Verification Phone</Label> <br />
															<span>{verificationPhone.number}</span><br />
														</FormGroup>
													</Col>
													<Col md={5}>
														<ActionButton
															icon="send"
															className="pull-right"
															style={{ marginTop: "5px" }}
															onClick={this.handleSendTestSMS}>Send Test SMS</ActionButton>
													</Col>
												</Row>
											</Panel.Body>
										</Panel>
									}
								</Col>
								{ (this.state.form.userTypeCode  === 'CER') &&
									<Col md={6}>
										<FormGroup>
											<Label>Companies Notifications</Label>
											<CompanyMultiselect name="subscribedCompanies"
												height={180} companies={this.state.form.subscribedAssociatedCompanies}/>
										</FormGroup>
									</Col>
								}
								{ (this.state.form.userTypeCode  === 'SPN') &&
									<Col md={6}>
										<FormGroup>
											<Label htmlFor="userSubscribed">
                                                Receive email notifications?
                                                {this.state.form.userSubscribedDisabled ?
                                                    <React.Fragment>
                                                        &nbsp;&nbsp;
                                                        <OverlayTrigger placement="right" overlay={sponsorUnsubscribedTooltip}>
                                                            <FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
                                                        </OverlayTrigger>
                                                    </React.Fragment>
                                                :null}
                                            </Label>
											<Switch name='userSubscribed' 
												labelLeft="No" 
												labelRight="Yes" 
												disabled={this.state.form.userSubscribedDisabled} 
												bsStyle='success' />
										</FormGroup>
									</Col>
								}
							</Row>
							<FormGroup>
								<Label htmlFor="email" required>Email</Label>
								<EmailBox 
									name="email"
									placeholder="Email" 
									required />
							</FormGroup>
						</Col>
						<Col md={5}>
							<Label htmlFor="avatarData">Choose your avatar</Label>
							<Avatar name="avatarData" />
							<em className="small">Click on the picture to browse a different one.</em>
							<FormGroup style={{marginTop: "5px"}}>
								<Label htmlFor="landingPage">Choose your landing page</Label>
								<Combo 
									items={this.state.resourceList} 
									placeholder="Choose your landing page"
									name="landingPage" />
							</FormGroup>
						</Col>
					</Row>
					<hr />
					<SaveCancel onCancel={this.onCancel} />
				</Form>
			</React.Fragment>)
	}
}

export default withRouter(ProfileTab);



// WEBPACK FOOTER //
// ./src/areas/main/profile/profile/ProfileTab.js